<template lang="pug">
  div.lead-organization
    div.lead-organization__form
      p.lead-organization__text Essa etapa permite que você organize seus contatos e tenha mais agilidade para encontrá-los dentro da base. Além disso, você pode escolher se vai enviar essa lista para outro usuário.
      .form-group.lead-organization__responsable(v-if="show_user_options")
        label.control-label(for='lead_responsable') Quem será o responsável por esses leads?
        #lead_responsable
          dropdown-select(:options="filtered_user_options",
                          v-model="selected_user_option",
                          :selected="selected_user_option"
                          @input="updateUserId")
      .form-group.lead-organization__fluxo
        strong.text-gray-color Enviar contatos para um fluxo?
        .toggler-inline
          input(type="checkbox", :checked="sent_to_flow")
          label(@click.stop='switchSendToFlow()') {{ sent_to_flow ? "Sim" : "Não" }}
          flows(@flow-selected="selectFlow",
                :user_id="selected_user",
                v-if="sent_to_flow")

      .form-group.lead-organization__group(v-if="remaining > 0")
        strong.text-gray-color(v-if="multiple_groups") Adicionar contatos restantes a um grupo?
        strong.text-gray-color(v-else) Adicionar contatos a um grupo?
        .toggler-inline.half-width
          input(type="checkbox", :checked="add_to_group")
          label(@click.stop='switchAddToGroup()') {{ add_to_group ? "Sim" : "Não" }}
          groups(@group-selected="selectGroup",
                :user_id="selected_user",
                v-if="add_to_group")

      div.lead-organization__filters
        div
          label Inserir tags nos contatos?
          tag-filter(
                    id="tags_filter"
                    @item-selected-items="updateTags",
                    :filter_item_selected_ids='selected_tags',
                    :default_label="'Nenhuma tag'")

        div
          label Tags selecionadas:
          tags(v-for="selectedTag in selected_tags",
               :key="selectedTag.id",
               :deletable="true",
               :tag="selectedTag",
               @remove-tag='removeTag')

    .groups(v-if="multiple_groups")
      .form-group
        .text-gray-color Confirme a criação de novos grupos e/ou a inserção de contatos em grupos existentes

        .contact-list-item-checkbox-item(v-for="(group, index) in groups", @click.stop='toogleCheck(index)')
          input(type="checkbox" :checked="group.selected" class="checkbox-inline" v-if="getShowCheckboxGroupConditions(group)")
          div(v-html='getGroupText(group)')
        .no-checkbox-inline.contact-list-item-checkbox-item(v-if="remaining > 0 && selected_group == null")
          label
            strong(v-if="remaining > 1") Os {{ remaining }} contatos restantes não serão adicionados a grupos.
            strong(v-else) O contato restante não será adicionado a um grupo.
        .no-checkbox-inline.contact-list-item-checkbox-item(v-else-if="selected_group && remaining > 0")
          label
            strong Inserir {{ remaining }} contatos 
            span no grupo 
            strong {{ selected_group.name }}
        .no-checkbox-inline.contact-list-item-checkbox-item(v-else)
          label
            span Não há contatos restantes na sua planilha.
</template>

<script>
export default {
  props: {
    multiple_groups: { default: false },
    groups: { default: null },
    remaining: { default: null }
  },
  components: {
    tagFilter: require('../shared/dropdown_multiple_kind/tag_filter.vue'),
    tags: require('../tags/tag.vue'),
    flows: require('../shared/autocomplete/flows.vue'),
    groups: require('../shared/autocomplete/groups.vue')
  },
  mixins: [
    require('../../mixins/users_options.coffee')
  ],
  data () {
    return {
      sent_to_flow: false,
      add_to_group: false,
      selected_user: Session.current_user.id,
      selected_user_option: null,
      selected_tags: [],
      selected_flow: null,
      selected_group: null,
      current_user_role: Session.current_user.role,
      current_user_id: Session.current_user.id,
      account_setting: Session.current_company.account_setting,
      check: false
    }
  },
  computed: {
    filtered_user_options() {
      let filtered_user_options = this.users_options
      filtered_user_options.shift()
      return filtered_user_options
    },
    show_user_options() {
      return this.current_user_role == 'manager' || 
      this.current_user_role == 'admin'
    }
  },
  methods: {
    getGroupText(group_params) {
      let group = group_params.group
      let user_name = this.users_options.find(obj => { if (obj.value !== null) { return obj.value.user_id_eq == group.user_id }}).text

      if (this.current_user_role == "manager" && group.id !== null) {
        return `<label>
                  <strong> Inserir ` + group_params.contacts_count + ` contatos </strong>
                  <span> no grupo </span>
                  <strong>` + group.name + `</strong>
                  <span> do usuário ` + user_name + `</strong>
                </label>`
      } else if (this.current_user_role !== "manager" && group.id !== null && group.user_id == this.current_user_id) {
        return `<label>
                  <strong> Inserir ` + group_params.contacts_count + ` contatos </strong>
                  <span> no seu grupo </span>
                  <strong>` + group.name + `</strong>
                </label>`
      } else if (this.current_user_role !== "manager" && group.id !== null && group.user_id != this.current_user_id) {
        return  `<span class="group_problem_error">
                  <strong> Você não pode adicionar contatos </strong>
                  <span> no grupo </span>
                  <strong>` + group.name + `</strong>
                  <span> do usuário ` + user_name + `</strong>
                </span>`
      } else if (group.action == 'updated' && group.id == null) {
        return  `<label>
                  <strong> Inserir ` + group_params.contacts_count + ` contatos </strong>
                  <span> no gropo </span>
                  <strong>` + group.name + `</strong>
                </label>`
      } else {
        return `<label>
                  <strong> Criar grupo ` + group.name + `</strong>
                  <span> com </span>
                  <strong>` + group_params.contacts_count + ` contatos </strong>
                </label>`
      }
    },
    getShowCheckboxGroupConditions(group_params) {
      let group = group_params.group
      return group.id == null || this.current_user_role == 'manager' || group.user_id == this.current_user_id
    },
    toogleCheck(index) {
      if (this.getShowCheckboxGroupConditions(this.groups[index])) {
        this.groups[index]["selected"] = !this.groups[index]["selected"]
        if (!this.groups[index]["selected"]) {
          this.$emit('remainingContacts', this.remaining + this.groups[index]["contacts_count"])
        } else {
          this.$emit('remainingContacts', this.remaining - this.groups[index]["contacts_count"])
        }
      }
    },
    updateTags(data) {
      this.selected_tags = data.selected_items
      let payload = {
        type: 'contact_tags',
        value: this.selected_tags.map(tag => {
          return tag.id
        })
      }
      this.$emit('tagsUpdated', this.selected_tags.map(function(tag){return {tag_id: tag.id}}))
    },
    removeTag(data) {
      this.selected_tags.remove(data)
    },
    updateUserId(data) {
      if (data) {
        this.selected_user = data.user_id_eq
        const payload = {
          type: 'user_id',
          value: Number(data.user_id_eq)
        }
      }
      this.$emit('userUpdated', this.selected_user_option.user_id_eq)
    },
    switchSendToFlow () {
      this.sent_to_flow = !this.sent_to_flow
      if(!this.sent_to_flow) {
        this.selected_flow = null
        const payload = {
          type: 'flow_data',
          value: null,
          switch: false
        }
      }
      this.$emit('flowSwitch', this.sent_to_flow)
    },
    switchAddToGroup () {
      this.add_to_group = !this.add_to_group
      if(!this.add_to_group) {
        this.selected_group = null
        const payload = {
          type: 'group_data',
          value: null,
          switch: false
        }
      }
      this.$emit('groupSwitch', this.add_to_group)
    },
    selectFlow (flow) {
      this.selected_flow = flow
      const payload = {
        type: 'flow_data',
        value: Number(this.selected_flow.id),
        switch: this.sent_to_flow
      }
      this.$emit('fillFlow', Number(this.selected_flow.id))
    },
    selectGroup (group) {
      this.selected_group = group
      const payload = {
        type: 'group_data',
        value: Number(this.selected_group.id),
        switch: this.add_to_group
      }
      this.$emit('fillGroup', Number(this.selected_group.id))
    }
  },
  mounted() {
    this.updateUserId(this.selected_user_option)
  },
  created() {
    this.sent_to_flow = false
    this.add_to_group = false
    this.selected_user_option = this.users_options.find(option => {
      return option.value && parseInt(option.value.user_id_eq) == Session.current_user.id
    }).value
  }
}
</script>

<style lang="sass">
.lead-organization
  font-family: Montserrat
  position: relative
  display: flex
  flex-direction: column
  width: 100%
  padding-top: 0
  margin-top: 45px

  .lead-organization__form
    label,
    strong
      display: block
      font-size: 12px
      text-align: justify
      font-weight: normal
      color: #6c7c88
    strong
      display: inline

  .lead-organization__text
    margin-bottom: 27px
    font-size: 13px
    color: #0e1e3c
    font-weight: 300

  .lead-organization__responsable
    margin-bottom: 30px
    .dropdown
      border: solid 1px #c4cacf
      border-radius: 3px
      width: 256px
    span
      float: right
      
  .v-autocomplete
    position: relative
    width: 100%
  .v-autocomplete-input-group
    margin-bottom: 0 !important
    width: 100%
  .lead-organization__fluxo,
  .lead-organization__group,
  .v-autocomplete-input-group
    margin-bottom: 30px
    .half-width
      width: 50%
    .toggler-inline
      display: flex
      flex-direction: row
      align-items: center
    input
      flex: 8
      height: 30px
      border-radius: 3px
      border: solid 1px #c4cacf
      padding-left: 8px
      width: 100% !important
    label
      margin-right: 14px
    .v-autocomplete-list
      z-index: 200
      position: absolute
      width: 100%
      text-align: left
      border-radius: 2px
      background-color: #ffffff
      border: solid 1px #e6e8ea
      margin-top: 2px
      position: absolute

      .v-autocomplete-list-item
        position: relative
        cursor: pointer
        height: 30px
        line-height: 30px !important
        background-color: #fff
        padding-left: 12px
        font-size: 12px
        text-align: justify
        color: #8d99a2

  .lead-organization__filters
    display: flex
    margin-bottom: 30px
    div
      margin-right: 24px
    .dropdown
      border: solid 1px #c4cacf
      border-radius: 3px
      width: 256px

      #dropdownFilterTags
        width: 100%
        z-index: 9999

    .tag
      margin-bottom: 5px

    .groups
      padding-top: 30px
      border-top: 1px solid rgb(198,206, 211)

    .checkbox-inline 
      padding-top: 20px
      float: left
      width: 100%

      label
        color: rgb(107,126,138)

    label:before
      border-radius: 0%
      height: 20px
      width: 20px

  .tag
    margin-bottom: 5px

  .groups
    padding-top: 30px
    border-top: 1px solid rgb(198,206, 211)

  .contact-list-item-checkbox-item
    display: flex
    text-align: center
    max-width: fit-content

    div
      margin: 10px

    label
      color: #6b7e8a
      cursor: pointer

    input[type=checkbox]:checked:after
      background: #08d4a7
      content: '\2714'
      color: #fff
      border-color: #08d4a7
      width: 20px
      height: 20px
      font-size: 16px
      display: block
      line-height: normal
      text-align: center

    .group_problem_error
      color: rgb(107,126,138)
      margin-left: -10px
      font-size: .9em

  .checkbox-inline
    padding-top: 20px
    float: left
    width: 20px
    height: 20px
    margin: 10px 0px

    label
      color: rgb(107,126,138)

    label:before
      border-radius: 0%
      height: 20px
      width: 20px

  .checkbox-inline + .checkbox-inline
    margin-left: 0

  .no-checkbox-inline
    padding-top: 20px
    float: left
    width: 100%

    label
      color: rgb(107,126,138)
</style>



// WEBPACK FOOTER //
// lead_organization.vue?4a9914c2